import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-info",
  "use": "icon-info-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-info\"><path d=\"M449.716 881.067c0 34.399 27.894 62.293 62.294 62.293 34.399 0 62.293-27.894 62.293-62.293 0-34.399-27.894-62.294-62.293-62.294-34.416 0-62.294 27.894-62.294 62.294zM591.736 150.991c0-44.031-35.697-79.726-79.743-79.726s-79.725 35.696-79.725 79.726c0 1.597 0.067 3.177 0.149 4.758h-0.018l17.301 508.563c0 34.399 27.894 62.293 62.293 62.293s62.293-27.894 62.293-62.293l17.301-508.563h-0.018c0.1-1.581 0.167-3.16 0.167-4.758z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/info.svg
// module id = Yfis
// module chunks = 16